(function () {
  function waitForYotpo(timeoutMs) {
    return new Promise(function (resolve, reject) {
      if (window.yotpoWidgetsContainer || window.yotpo) {
        resolve();
        return;
      }
      var start = Date.now();
      var timer = setInterval(function () {
        if (window.yotpoWidgetsContainer || window.yotpo) {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - start > timeoutMs) {
          clearInterval(timer);
          reject(new Error('Yotpo loader timed out'));
        }
      }, 150);
    });
  }

  function initYotpoWidgets(root) {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets(false, root);
      return;
    }
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
    }
  }

  function mountReviews(section) {
    if (section.dataset.yotpoReviewsMounted === 'true') return;

    var template = section.querySelector('[data-yotpo-reviews-template]');
    var mount = section.querySelector('[data-yotpo-reviews-mount]');
    if (!template || !mount || !template.content) return;

    section.dataset.yotpoReviewsMounted = 'true';
    mount.appendChild(template.content.cloneNode(true));

    waitForYotpo(12000)
      .then(function () {
        initYotpoWidgets(mount);
      })
      .catch(function () {
        initYotpoWidgets(mount);
      });
  }

  function observeSection(section) {
    if (!('IntersectionObserver' in window)) {
      mountReviews(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          mountReviews(section);
        });
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(section);
  }

  function init() {
    document.querySelectorAll('[data-yotpo-reviews-lazy]').forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-yotpo-reviews-lazy]');
    if (section) observeSection(section);
  });
})();
